export const LESSON_PLANNER_CONTEXT_KEY = "teachleague_gradebook_insight_context";
export const LESSON_PLANNER_CONTEXT_EVENT = "teachleague:planner-context-updated";

export const saveLessonPlannerContext = (payload) => {
  if (typeof window === "undefined" || !window.sessionStorage) return false;

  try {
    window.sessionStorage.setItem(
      LESSON_PLANNER_CONTEXT_KEY,
      JSON.stringify(payload)
    );
    window.dispatchEvent(new CustomEvent(LESSON_PLANNER_CONTEXT_EVENT));
    return true;
  } catch (error) {
    console.error("Unable to store lesson planner context:", error);
    return false;
  }
};

export const loadStoredLessonPlannerContext = () => {
  if (typeof window === "undefined" || !window.sessionStorage) return null;

  const rawContext = window.sessionStorage.getItem(LESSON_PLANNER_CONTEXT_KEY);
  if (!rawContext) return null;

  window.sessionStorage.removeItem(LESSON_PLANNER_CONTEXT_KEY);

  try {
    return JSON.parse(rawContext);
  } catch (error) {
    console.error("Unable to parse lesson planner context:", error);
    return null;
  }
};
